import { FC, ReactElement, Component, useState, useEffect, HTMLAttributes } from "react";
import Dropzone from "react-dropzone";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface Props extends Record<string, any> {
  input: {
    value: Array<{ name: string }>;

    onChange: Function;
  };
  fileDescription: string;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  description?: ReactElement<typeof Component> | any;
  alwaysDisplayDropzone?: boolean;
}

const FileUploader: FC<Props> = (props: Props): JSX.Element => {
  const {
    fileDescription,
    input,
    alwaysDisplayDropzone = true,
    description = (
      <>
        Drag and drop or <span>browse</span> files to upload your {fileDescription} file
      </>
    ),
  } = props;
  const [fileUploadName, setFileUploadName] = useState("");

  useEffect((): void => {
    if (input.value) {
      setFileUploadName(input.value[0].name);
    } else {
      setFileUploadName("");
    }
  }, [input.value]);

  const uploadedFile = (
    <div className="dropped-file-container">
      <span className="dropped-file-filename">{fileUploadName}</span>
      <span
        className="caprx-icon-inputclose"
        onClick={(): void => {
          input.onChange();
        }}
      ></span>
    </div>
  );

  const displayDropzone = alwaysDisplayDropzone || fileUploadName === "";

  // TS for some reason doesn't like just spreading the root/input props we get from DropZone onto the elements so we need to cast.
  return (
    <div className="file-uploader-container">
      {displayDropzone && (
        <Dropzone
          multiple={false}
          onDrop={(file): void => {
            input.onChange(file);
          }}
        >
          {({ getRootProps, getInputProps }): JSX.Element => (
            <div {...(getRootProps({ className: "file-upload" }) as Partial<HTMLAttributes<HTMLDivElement>>)}>
              <div className="file-upload-img" />
              {/* @ts-ignore */}
              <input {...getInputProps()} />
              <div className="file-upload-description">{description}</div>
            </div>
          )}
        </Dropzone>
      )}
      {fileUploadName && uploadedFile}
    </div>
  );
};

export default FileUploader;
